import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { newHost } from '../../pages/Categories/CategoryProfile';
import { newImageUrl } from '../../pages/Manufacturers/ManufactureProfile';
import defaultImage from "../../assets/svg/defultImage.svg";
import noteIcon from "../../assets/svg/note-1-svgrepo-com 1.svg";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Modal } from 'react-bootstrap';
import { Circle } from '@mui/icons-material';


const OrdersHistory = () => {
     const token = localStorage.getItem("token");
     const [fromDate, setFromDate] = useState("");
     const [toDate, setToDate] = useState("");
     const [pagination, setPagination] = useState(null);
     const [currentPage, setCurrentPage] = useState(1);
     const perPage = 10;
     const [orders, setOrders] = useState([]);

    const [expandedOrder, setExpandedOrder] = useState(null);
    const [expandedVehicle, setExpandedVehicle] = useState(null);
    const [expandedTrip, setExpandedTrip] = useState(null);
    const [expandedService, setExpandedService] = useState(null);
    const [expandedSub, setExpandedSub] = useState({});
    const [isChecked, setIsChecked] = useState({})

    const accordionStyle = {
  backgroundColor: "#F9F9F9",
  my: 2,
  py: 1,
  border: "none",
  outline: "none",
  "&:before": { display: "none" },
  "&.Mui-expanded": { boxShadow: "none" },
};

  const handleSearch = () => {
    setCurrentPage(1);
    getOrders(1);
  };

  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setCurrentPage(1);
    setTimeout(() => getOrders(1), 0);
  };
      const getOrders = async (page = 1) => {
            const params = new URLSearchParams();
      params.append("page", page);
      params.append("per_page", perPage);
      if (fromDate) params.append("from", fromDate);
      if (toDate) params.append("to", toDate);
        try {
          const response = await axios.get(`${newHost}stuff/get-orders-history?${params.toString()}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
         const orderItems = response.data.data?.data 
         setOrders(orderItems)
         setPagination(response.data.data?.pagination || null);
const ordersCheckedState = {};

Object.entries(orderItems).forEach(([date, ordersList]) => {
  ordersList.forEach(order => {
    const allItems = [];

    order.categories.forEach(cat =>
      cat.subcategories.forEach(sub =>
        sub.items.forEach(item => {
          allItems.push(item);
        })
      )
    );

    const hasRejected = allItems.some(item => item.status === "rejected");

    ordersCheckedState[order.id] = hasRejected;
  });
});

setIsChecked(ordersCheckedState);
            

          
    
        } catch (error) {
          console.log(error.response);
        }
      };
      useEffect(() => {
        getOrders()
    
      }, [currentPage])
      const formatArabicDate = (date) => {
        if (!date) return "طلبات لم تكتمل";
        return new Date(date).toLocaleDateString("ar-EG", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
      };
          const [noteValue, setNoteValue] = useState("");
          const [imagePreview, setImagePreview] = useState(null)
          const [selectedFile, setSelectedFile] = useState(null);
          const [showModal, setShowModal] = useState(false);
          const [itemStatus, setItemStatus] = useState({}) 
          const [currentItem, setCurrentItem] = useState(null);
      
     const openModal = (sub) => {
            setItemStatus(sub)
  
      
        setShowModal(true);
      };
   
  return (
  <>
     <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName='custom-modal-campaigns-width'>
        <Modal.Header className='d-flex align-items-center' >
          <Modal.Title style={{ direction: "rtl" }} className='fw-bold fs-5 text-center w-100 m-0'>
       ملاحظات و مرفقات علي الخدمات
          </Modal.Title>

        </Modal.Header>
        <Modal.Body className='m-2' style={{ direction: "rtl" }}>
          {itemStatus?.items
  ?.filter(item => item.status === "rejected")
  .map((item, index) => (
    <>
      <div>
            <p className='fw-bold'>{`خدمة ${item.service_name}`}</p>
        <h6>{`ملاحظة الفني`}</h6> 
      
        <p>{item.rejection_reason ? item.rejection_reason : "-"}</p>
      
      </div>

      <div className="my-3">
        <p>صورة توضح حالة الجزء</p>
        <div className="p-4 w-100 rounded-3 d-flex justify-content-center align-items-center">
          <img
            src={
              item.image_url
                ? `${newImageUrl}${item.image_url}`
                : defaultImage
            }
            alt="preview"
            style={{
              width: "100%",
              height: 150,
              objectFit: "cover",
              borderRadius: 10
            }}
          />
        </div>
      </div>
    </>
  ))}
 
        </Modal.Body>

      </Modal>

    <div className='m-4 min-vh-100'>
     

      <div className="row g-3">
        <div className="col-12" dir="rtl">
           <div
        className="mb-4 p-3 p-md-4 rounded-4 shadow-sm"
        style={{
          background: "linear-gradient(135deg, #f8f9ff 0%, #eef1ff 100%)",
          border: "1px solid #e0e4ff",
        }}
      >
        <h6 className="fw-bold mb-3" style={{ color: "#000000" }}>
          🗓 تصفية حسب التاريخ
        </h6>
        <div className="row g-3 align-items-end">
          <div className="col-12 col-sm-4">
            <label className="form-label small fw-semibold text-muted mb-1">
              من تاريخ
            </label>
            <input
              type="date"
              className="form-control rounded-3 border-0 shadow-sm"
              style={{ background: "#fff", fontSize: "0.9rem" }}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-4">
            <label className="form-label small fw-semibold text-muted mb-1">
              إلى تاريخ
            </label>
            <input
              type="date"
              className="form-control rounded-3 border-0 shadow-sm"
              style={{ background: "#fff", fontSize: "0.9rem" }}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-4 d-flex gap-2 text-end">
            <button
              className="btn fw-semibold flex-grow-1 rounded-3 text-white btn-dark"
              style={{
                // background: "linear-gradient(135deg, #3d4fd7, #6c63ff)",
                // fontSize: "0.9rem",
              }}
              onClick={handleSearch}
            >
              بحث
            </button>
            {(fromDate || toDate) && (
              <button
                className="btn btn-outline-secondary rounded-3 fw-semibold"
                style={{ fontSize: "0.9rem" }}
                onClick={handleReset}
              >
                مسح
              </button>
            )}
          </div>
        </div>

        {/* Pagination info summary */}
        {pagination && (
          <div className="mt-3 d-flex flex-wrap gap-3">
            <span
              className="badge rounded-pill px-3 py-2"
              style={{
                background: "#e8eaff",
                color: "#050505",
                fontSize: "0.8rem",
              }}
            >
              إجمالي الأيام: {pagination.total_dates}
            </span>
            <span
              className="badge rounded-pill px-3 py-2"
              style={{
                background: "#e8eaff",
                color: "#000000",
                fontSize: "0.8rem",
              }}
            >
              الصفحة {pagination.current_page} من {pagination.last_page}
            </span>
          </div>
        )}
      </div>
{
Object.entries(orders).map(([date, ordersList]) => {
 
  return(
  <div key={date}>
    <h6>{formatArabicDate(date)}</h6>

    {ordersList.map((order) => (
      <Accordion
        key={order.id}
        expanded={expandedOrder === order.id} 
        onChange={() =>
          setExpandedOrder(expandedOrder === order.id ? null : order.id)
        }
        sx={accordionStyle}
        className="shadow-sm"
      >
        {/* ===== HEADER ===== */}
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div className="row w-100">
            <div className="col-8 d-flex align-items-center">
              <img
                style={{ width: 30, height: 30 }}
                src={order.order_status?.image_url || defaultImage}
              />
              <span className="fw-bold mx-2">{`ORD-#${order.id}`}</span>
              Order
            </div>

            <div className="col-4 d-flex justify-content-end fw-bold">
              {Number(order.total).toLocaleString("en-US")} ج.م
            </div>
          </div>
        </AccordionSummary>

        <AccordionDetails>

          {/* ===== VEHICLE ===== */}
          <Accordion
            expanded={expandedVehicle === order.id}
            onChange={() =>
              setExpandedVehicle(expandedVehicle === order.id ? null : order.id)
            }
            sx={accordionStyle}
            className='shadow-sm'
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              تفاصيل السيارة المستخدمة
            </AccordionSummary>

            <AccordionDetails>
              <div className="border rounded-4 p-4 d-flex gap-5">
                <div>
                  <h6 className="main-text-color">اسم السيارة</h6>
                  <h6>
                    {order?.vehicle_assignments?.current_assignment?.vehicle?.model?.name}{" "}
                    {order?.vehicle_assignments?.current_assignment?.vehicle?.model?.brand?.name}
                  </h6>
                </div>

                <div>
                  <h6 className="main-text-color">كود السيارة</h6>
                  <h6>
                    {order?.vehicle_assignments?.current_assignment?.vehicle?.id}
                  </h6>
                </div>

                <div>
                  <h6 className="main-text-color">رقم اللوحة</h6>
                  <h6>
                    {order?.vehicle_assignments?.current_assignment?.vehicle?.plate_number}
                  </h6>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>

          {/* ===== TRIPS ===== */}
          <Accordion
            expanded={expandedTrip === order.id}
            onChange={() =>
              setExpandedTrip(expandedTrip === order.id ? null : order.id)
            } 
            sx={accordionStyle}
            className='shadow-sm'
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              معلومات اساسية عن الرحلة
            </AccordionSummary>

            <AccordionDetails>
              {order.trips?.map((trip, idx) => (
                <div key={idx} className="border rounded-4 p-4 my-3 d-flex gap-5">
                  <div>
                    <h6 className="main-text-color">تاريخ الرحلة</h6>
                    <h6>{new Date(trip.started_at).toLocaleDateString()}</h6>
                  </div>

                  <div>
                    <h6 className="main-text-color">مدة الرحلة</h6>
                    <h6>{trip.duration || trip.formatted_duration}</h6>
                  </div>

                  <div>
                    <h6 className="main-text-color">المسافة</h6>
                    <h6>-</h6>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>

          {/* ===== SERVICES ===== */}
          <Accordion
            expanded={expandedService === order.id}
            onChange={() =>
              setExpandedService(expandedService === order.id ? null : order.id)
            }
            sx={accordionStyle}
            className='shadow-sm'
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              تفاصيل الخدمة المطلوبة
            </AccordionSummary>

            <AccordionDetails>
              {order.categories?.map((item) =>
                item.subcategories.map((sub) => 
                   {
  const hasAttachment = sub.items.some(item =>
  item.status === "rejected" &&
  (item.rejection_reason || item.image_url)
);
                  return (
                  <Accordion
                    key={sub.id}
                    expanded={expandedSub[order.id] === sub.id}
                    onChange={() =>
                      setExpandedSub((prev) => ({
                        ...prev,
                        [order.id]:
                          prev[order.id] === sub.id ? null : sub.id
                      }))
                    }
                    sx={accordionStyle}
                    className='shadow-sm'
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          style={{ width: 30, height: 30 }}
                          src={
                            item.icon_url
                            ? item.slug === "cover"
                              ? item.icon_url
                              : `${newImageUrl}${item.icon_url}`
                            : defaultImage
                          }
                        />
                        <h6 className="m-0">{sub.name}</h6>
                      </div>
                    </AccordionSummary>

                    <AccordionDetails>
                      <div className="border rounded-4 p-4">

                        <div className="d-flex justify-content-between">
                          <div className="d-flex gap-5 flex-wrap">
                            {sub.items.map((service) => 

                            (
                              <div key={service.id}>
                                <h6 className="main-text-color">
                                  {service.service_name}
                                </h6>

                                <h6>
                                  {Number(service.final_price).toLocaleString(
                                    "en-US"
                                  )}{" "}
                                  ج.م
                                </h6>

                                <h6
                                  style={{
                                    color:
                                      service.status === "rejected"
                                        ? "#A80101"
                                        : "#3BBFAD"
                                  }}
                                >
                                  {service.status === "rejected"
                                    ? "لم يتم"
                                    : "تم"}
                                </h6>
                              </div>
                            )
                            )}
                          </div>
                          <IconButton className='p-0'  size='small' disableRipple disabled={!isChecked[order.id]}>
                              <div
                               
                                className="position-relative"
                                onClick={() => openModal(sub)}
                                
                              >
                                <img
                        
                                  src={noteIcon}
                                  alt="note"
                                  style={{ width: 26, cursor: "pointer" }}
                                />
                                {hasAttachment && (
                                  <Circle
                                    sx={{
                                      fontSize: 8,
                                      color: "#FF0B0B",
                                      position: "absolute",
                                      top: 0,
                                      right: 0
                                    }}
                                  />
                                )}
                              </div>
                          </IconButton>
                                
                             
                        </div>

                      </div>
                    </AccordionDetails>
                  </Accordion>
                )
                }
              )
              )}
            </AccordionDetails>
          </Accordion>

        </AccordionDetails>
      </Accordion>
    ))}
  </div>
)
})}
          {/* {Object.entries(orders).map(([date, ordersList]) => (
            <div key={date}>
              <h6>{formatArabicDate(date)}</h6>

              {ordersList.map((order) => {


      return (
        <>
          <div style={{ backgroundColor: "#F9F9F9", }} key={order.id} class="accordion-item  my-3">
            <div class="accordion " id={`accordion-${order.id}`}>
              <h2 class="accordion-header 
                    accordion-header-responsive remove-border-focus d-flex align-items-center px-2">
                <img style={{ width: "30px", height: "30px" }} src={order.order_status?.image_url ? `${order.order_status?.image_url}` : defaultImage} alt="" />


                <button class="accordion-button fix-accordion-dir text-black bg-transparent d-flex justify-content-between align-items-center w-100" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${order.id}`} aria-expanded="true" aria-controls={`collapse-${order.id}`}>
                  <div className="row w-100">
                    <div className="col-8 d-flex justify-content-start">

                      <span className="text-dark mx-2 my-0 fw-bold">{`ORD-#${order.id}`}</span>
                      Order
                    </div>
                    <div className="col-4 d-flex justify-content-end align-items-center gap-1">
                      <span className="text-dark fw-bold mx-2 ">{`${Number(order.total)?.toLocaleString("en-Us")} ج.م`}</span>

                    </div>
                  </div>
                </button>



              </h2>
    <div id={`collapse-${order.id}`} class="accordion-collapse collapse" data-bs-parent={`#accordion-${order.id}`}>
      <div class="accordion-body shadow-sm body-accordion-profile  rounded-2">
        <div className='my-2 '>
          <div style={{ backgroundColor: "#F9F9F9", }} key={order.id} class="accordion-item  my-3">
            <div class="accordion " id={`accordion-${order?.vehicle_assignments?.current_assignment?.vehicle?.id}`}>
              <h2 class="accordion-header accordion-header-responsive remove-border-focus d-flex align-items-center px-2">

                <button class="accordion-button fix-accordion-dir text-black bg-transparent d-flex justify-content-between align-items-center w-100" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${order?.vehicle_assignments?.current_assignment?.vehicle?.id}`} aria-expanded="true" aria-controls={`collapse-${order?.vehicle_assignments?.current_assignment?.vehicle?.id}`}>
                  تفاصيل السيارة المستخدمة

                </button>



              </h2>
              <div id={`collapse-${order?.vehicle_assignments?.current_assignment?.vehicle?.id}`} class="accordion-collapse collapse" data-bs-parent={`#accordion-${order?.vehicle_assignments?.current_assignment?.vehicle?.id}`}>
                <div class="accordion-body shadow-sm body-accordion-profile  rounded-2">
                  <div className='my-4 border rounded-4 p-4 '>
                    <div style={{ gap: "100px" }} className="d-flex align-items-center">
                      <div className="">
                        <h6 className="main-text-color label-size">اسم السيارة</h6>
                        <h6 className="label-size">{`${order?.vehicle_assignments?.current_assignment?.vehicle?.model?.name} ${order?.vehicle_assignments?.current_assignment?.vehicle?.model?.brand.name}`}</h6>
                      </div>
                      <div className="">
                        <h6 className="main-text-color label-size">كود السيارة</h6>
                        <h6 className="label-size">{order?.vehicle_assignments?.current_assignment?.vehicle?.id}</h6>
                      </div>
                      <div className="">
                        <h6 className="main-text-color label-size">رقم اللوحة</h6>
                        <h6 className="label-size">{order?.vehicle_assignments?.current_assignment?.vehicle?.plate_number}</h6>
                      </div>
                    </div>
                  </div>


                </div>

              </div>

            </div>
          </div>
        </div>
        <div className='my-2 '>
          <div style={{ backgroundColor: "#F9F9F9", }} class="accordion-item  my-3">
            <div class="accordion " id={`accordion-${order.converted_from_request_id}-${order.id}`}>
              <h2 class="accordion-header accordion-header-responsive remove-border-focus d-flex align-items-center px-2">

                <button class="accordion-button fix-accordion-dir text-black bg-transparent d-flex justify-content-between align-items-center w-100" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${order.converted_from_request_id}-${order.id}`} aria-expanded="true" aria-controls={`collapse-${order.converted_from_request_id}-${order.id}`}>
                  معلومات اساسية عن الرحلة

                </button>



              </h2>
              <div id={`collapse-${order.converted_from_request_id}-${order.id}`} class="accordion-collapse collapse" data-bs-parent={`#accordion-${order.converted_from_request_id}-${order.id}`}>
                <div class="accordion-body shadow-sm body-accordion-profile  rounded-2">
                  {order.trips?.map((trip) =>
                    <div className='my-4 border rounded-4 p-4 '>
                      <div style={{ gap: "100px" }} className="d-flex align-items-center">
                        <div className="">
                          <h6 className="main-text-color label-size">تاريخ الرحلة</h6>
                          <h6 className="label-size">{new Date(trip.started_at).toLocaleDateString()}</h6>
                        </div>
                        <div className="">
                          <h6 className="main-text-color label-size">مدة الرحلة</h6>
                          <h6 className="label-size">{trip.duration?  trip.duration : trip.formatted_duration}</h6>
                        </div>
                        <div className="">
                          <h6 className="main-text-color label-size">المسافة المقطوعة </h6>
                          <h6 className="label-size">-</h6>
                        </div>
                      </div> 
                    </div>
                  )}



                </div>

              </div>

            </div>
          </div>
        </div>

        <div className='my-2 '>
          <div style={{ backgroundColor: "#F9F9F9", }} key={`${order.id}-${order.converted_from_request_id}`} class="accordion-item  my-3">
            <div class="accordion " id={`accordion-${order.id}-${order.converted_from_request_id}`}>
              <h2 class="accordion-header accordion-header-responsive remove-border-focus d-flex align-items-center px-2">

                <button class="accordion-button fix-accordion-dir text-black bg-transparent d-flex justify-content-between align-items-center w-100" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${order.id}-${order.converted_from_request_id}`} aria-expanded="true" aria-controls={`collapse-${order.id}-${order.converted_from_request_id}`}>
                  تفاصيل الخدمة المطلوبة

                </button>



              </h2>
  <div id={`collapse-${order.id}-${order.converted_from_request_id}`} class="accordion-collapse collapse" data-bs-parent={`#accordion-${order.id}-${order.converted_from_request_id}`}>
    <div class="accordion-body shadow-sm body-accordion-profile  rounded-2">
      {order.categories?.map((item) => 
         item.subcategories.map((sub)=>
           <div style={{ backgroundColor: "#F9F9F9", }} key={sub.id} class="accordion-item  my-3">
          <div class="accordion " id={`accordion-${sub.id}`}>
            <h2 class="accordion-header accordion-header-responsive remove-border-focus d-flex align-items-center px-2">

              <button class="accordion-button fix-accordion-dir text-black bg-transparent d-flex justify-content-between align-items-center w-100" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${sub.id}`} aria-expanded="true" aria-controls={`collapse-${sub.id}`}>
                <div className="d-flex align-items-center gap-2">
                  <img style={{width:"30px", height:"30px"}} src={item.icon_url? `${newImageUrl}${item.icon_url}` : defaultImage} alt="" />
                 <h6 className="m-0">{sub?.name}</h6>
                </div>

              </button>




            </h2>
            <div id={`collapse-${sub.id}`} class="accordion-collapse collapse" data-bs-parent={`#accordion-${sub.id}`}>
              <div class="accordion-body shadow-sm body-accordion-profile  rounded-2">
                
                      

                          <div className='my-4 border rounded-4 p-4 '>
                            <div className="d-flex justify-content-between align-items-center">
                                  <div style={{ gap: "100px" }} className="d-flex align-items-center">
                                 
                                {sub.items.map((service)=>
                           <>
                           <div className="">
                               <div className="">
                                <h6 className="main-text-color label-size">{service.service_name}</h6>
                                <h6 className="label-size">{`${Number(service.final_price)?.toLocaleString("en-Us")} ج.م`}</h6>
                                 <div className="my-1">
                                <h6 style={{color: service.status == "rejected" ? "#A80101" :"#3BBFAD"}} className="">{service.status == "rejected"? "لم يتم" : "تم"}</h6>
                              </div>
                              </div>
                           
                           </div>
                           
                           
                           </>
                       )}
                           

                      </div>
                       <div className="">
                                    <img 
                                      src={noteIcon}
                                      alt="note"
                                      style={{ width: "24px", cursor: "pointer" }}
                                    />
                    </div>
   
                            </div>
                           

                    </div>
                  </div>
                </div>



              </div>

            </div>

       
        )
     

      )}



    </div>

  </div>

            </div>
          </div>
        </div>


      </div>

    </div>
            </div>
          </div>
        </>
      )
    }


    )}
  </div>
))} */}


        </div>
      </div>
    </div>
  
  </>
  )
}

export default OrdersHistory